<template>
	<div class="card-wrapper">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "j-card"
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";

.card-wrapper {
	width: 100%;
	border: 1px solid var(--color7);
	border-radius: var(--borderRadius2);
	box-shadow: 0 4px 10px -2px var(--color7-alpha-30);
	/* overflow: hidden; */
}
</style>
